(function () {
  if (!document.documentElement.classList.contains('m-page-loading')) return;

  var revealSelector = [
    '.m-hero-tr__content > *',
    '.m-promo-tr__copy > *',
    '.m-category-card-tr',
    '.m-products-tr__head > *',
    '.m-product-tr',
    '.m-feature-tr__main',
    '.m-feature-tr__side > *',
    '.m-scalpify-copy-block',
    '.m-scalpify-tr__visuals img',
    '.m-review-tr',
    '.m-footer-trust-clean > div',
    '.m-footer-clean__grid > div',
    '.m-about__img',
    '.m-about__content > *',
    '.m-newsletter__inner > *',
    '.m-trust__item',
    '.m-pdp__media-item',
    '.m-pdp__sticky > *',
    '.m-pdp-related__card'
  ].join(',');

  function removeLoader() {
    document.documentElement.classList.remove('m-page-loading');
    document.documentElement.classList.add('m-page-loaded');
  }

  function markRevealItems(root) {
    var scope = root || document;
    var items = scope.querySelectorAll(revealSelector);
    items.forEach(function (item, index) {
      if (item.classList.contains('m-motion-reveal')) return;
      item.classList.add('m-motion-reveal');
      item.style.setProperty('--m-motion-order', index % 8);
    });
  }

  function revealVisibleItems(root) {
    var scope = root || document;
    scope.querySelectorAll('.m-motion-reveal').forEach(function (item) {
      item.classList.add('m-motion-visible');
    });
  }

  function initObserver(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.m-motion-reveal:not(.m-motion-visible)');

    if (!('IntersectionObserver' in window)) {
      revealVisibleItems(scope);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('m-motion-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function setHeaderState() {
    document.body.classList.toggle('m-has-scrolled', window.scrollY > 12);
  }

  function init(root) {
    markRevealItems(root);
    initObserver(root);
    setHeaderState();
  }

  window.addEventListener('load', function () {
    window.setTimeout(removeLoader, 180);
    init(document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(removeLoader, 900);
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('scroll', function () {
    if (window.__matsuScrollTicking) return;
    window.__matsuScrollTicking = true;
    window.requestAnimationFrame(function () {
      setHeaderState();
      window.__matsuScrollTicking = false;
    });
  }, { passive: true });
})();
